export default "__VITE_ASSET__C6r81Ap5__"